/**
 * Scroll tools for the front-end.
 *
 * IMPORTANT: There is a separate version of this for the editor.
 */
H_Tools.scroll = (() => {
    let throttleTimeout;
    let throttleDelay = 100;

    /**
     * A throttle function to be called every time the viewport is scrolled. Emits a custom
     * `scroll-throttle` event to the window every `throttleDelay` milliseconds as long as the
     * function keeps getting called.
     */
    function scrollThrottle() {
        if (!throttleTimeout) {
            throttleTimeout = setTimeout(function () {
                window.dispatchEvent(new Event('scroll-throttle'));
                throttleTimeout = null;
            }, throttleDelay);
        }
    }

    /**
     * Updates the following variables in the returned object:
     *
     * - `H_Tools.viewport.isScrollingDown` - Whether the viewport is being scrolled down
     * - `H_Tools.viewport.lastScrollTop` - The last scroll top position
     */
    function updateScrollState() {
        const currentScrollTop =
            window.scrollY || document.documentElement.scrollTop;

        H_Tools.viewport.isScrollingDown =
            currentScrollTop > H_Tools.viewport.lastScrollTop;

        // Update the last scroll position
        H_Tools.viewport.lastScrollTop = currentScrollTop;
    }

    window.addEventListener('scroll', scrollThrottle);
    window.addEventListener('scroll-throttle', updateScrollState);

    // Return an object to expose variables and functions
    return {
        isScrollingDown: false,
        lastScrollTop: 0,
    };
})();
